// extracted by mini-css-extract-plugin
module.exports = {"toolTip":"PieChart_toolTip__38tcH","toolTipColor":"PieChart_toolTipColor__ukyaj"};